import { useMutation } from "@tanstack/react-query";
import { createPortalSession } from "../services/apiCustomer";
import toast from "react-hot-toast";

export function usePortalSession() {
  return useMutation({
    mutationFn: async () => await createPortalSession(),
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
  });
}
